import { render, staticRenderFns } from "./bannerDetails.vue?vue&type=template&id=0a11ad7a&scoped=true"
import script from "./bannerDetails.vue?vue&type=script&lang=js"
export * from "./bannerDetails.vue?vue&type=script&lang=js"
import style0 from "./bannerDetails.vue?vue&type=style&index=0&id=0a11ad7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a11ad7a",
  null
  
)

export default component.exports